import ActivitiesView from "@components/order/components/activity/ActivitiesView";
import AppContext from "@helpers/context";
import { addStockAdjustmentActivity, getStockAdjustmentActivity } from "@network/api/stock-adjustment";
import { Notifications } from "d-react-components";
import { map } from "lodash";
import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

const StockAdjustmentDetailActivity = () => {
  const { adjustmentDetail } = useContext(AppContext);
  const activityList = useRef(null);
  const { t } = useTranslation();

  const source = (paging: any) => {
    const body = { id: adjustmentDetail?.id };
    return getStockAdjustmentActivity(body, paging?.pageIndex);
  };

  const transformer = (res: any) => {
    const activityList = res?.data?.data?.activities ?? [];
    return map(activityList, (item) => ({
      ...item,
      files: map(item.attachment, (attItem) => attItem?.attachment),
    }));
  };

  const onClickSendComment = (comment: any, attachment: any) => {
    const body = {
      id: adjustmentDetail?.id,
      comment,
      attachment: map(attachment, (item) => item?.key),
    };
    return addStockAdjustmentActivity(body).then(() => {
      Notifications.showSuccess(t("addCommentSuccess"));
    });
  };

  return (
    <ActivitiesView
      hideType
      source={source}
      transformer={transformer}
      setRef={(listRefParams: any) => (activityList.current = listRefParams)}
      onClickSendComment={onClickSendComment}
      isInstantUploadAttach
    />
  );
};

export default StockAdjustmentDetailActivity;
